import React from 'react';
import { generateTimeSlots } from '../../utils/timeUtils';
import { CALENDAR_SETTINGS } from '../../utils/constants';

/**
 * 時間軸コンポーネント（カレンダーの左側に表示）
 */
const TimeSlots = () => {
  const timeSlots = generateTimeSlots();
  const { GRID_ROW_HEIGHT } = CALENDAR_SETTINGS;

  return (
    <div className="time-slots">
      {timeSlots.map((time, index) => {
        // 00分の場合のみ時刻を表示（1時間ごと）
        const showLabel = time.endsWith(':00');

        return (
          <div
            key={time}
            className="time-slot"
            style={{
              height: `${GRID_ROW_HEIGHT / 4}px`, // 15分 = 1/4時間
              position: 'relative',
              borderTop: time.endsWith(':00') ? '1px solid transparent' : 'none',
            }}
          >
            {showLabel && (
              <span className="time-label">{time}</span>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default TimeSlots;
